export const getCard1 = (state) => state.table2.card1;
export const getCard2 = (state) => state.table2.card2;
export const getCard3 = (state) => state.table2.card3;
export const getCard4 = (state) => state.table2.card4;
export const getBb = (state) => state.table2.bb;
export const getStake = (state) => state.table2.stake;
export const getTs = (state) => state.table2.ts;
export const getGgps = (state) => state.table2.ggps;
export const getSuit = (state) => state.table2.suit;
export const getSuitQuality = (state) => state.table2.suitQuality;
export const getTableCombinations = (state) => state.table2;
